import axios from "axios";
import Config from "../../config/index";
import {
  GET_GST_NUMBER_VERIFY_FAILURE,
  GET_GST_NUMBER_VERIFY_REQUEST,
  GET_GST_NUMBER_VERIFY_SUCCESS,
  GET_STATUS_FAILURE,
  GET_STATUS_REQUEST,
  GET_STATUS_SUCCESS,
} from "./statusTypes";
let baseUrl = Config.baseUrl;

const getStatusRequest = () => {
  return {
    type: GET_STATUS_REQUEST,
  };
};

const getStatusSuccess = (payload) => {
  return {
    type: GET_STATUS_SUCCESS,
    payload: payload,
  };
};

const getStatusFaliure = (error) => {
  return {
    type: GET_STATUS_FAILURE,
    payload: error,
  };
};

const getStatus = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getStatusRequest());
    let url = `${baseUrl}/vendor/get_not_approved?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getStatusSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getStatusFaliure(err.message));
      });
  };
};
const getDataByGstNumberRequest = () => {
  return {
    type: GET_GST_NUMBER_VERIFY_REQUEST,
  };
};

const getDataByGstNumberSuccess = (payload) => {
  return {
    type: GET_GST_NUMBER_VERIFY_SUCCESS,
    payload: payload,
  };
};

const getDataByGstNumberFaliure = (error) => {
  return {
    type: GET_GST_NUMBER_VERIFY_FAILURE,
    payload: error,
  };
};

const getDataByGstNumber = (gstNumber, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getDataByGstNumberRequest());
    let url = `${baseUrl}/vendor/validate_gst?gstNo=${gstNumber}`;
    console.log(url);

    return axios
      .get(url, headers)
      .then((response) => {
        console.log("response", response);
        dispatch(getDataByGstNumberSuccess(response.data));
        return response.data; // <-- return actual data
      })
      .catch((err) => {
        dispatch(getDataByGstNumberFaliure(err.message));
        throw err; // <-- let caller handle error
      });
  };
};

export { getDataByGstNumber, getStatus };
